import FJMyCreationsDetail from './FJMyCreationsDetail';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../../hooks/useLocalStore';
import { useEffect, useCallback } from 'react';
import FJActionCommunity from '../../../../../redux/action/FJActionCommunity';
import FJConstant from '../../../../../constants/FJConstant';
import { setSliceMyCreationsPageScene } from '../../../../../redux/slices/FJSliceCommunity';
const FJMyCreationsDetailContainer = props => {
    const { active } = props;
    const dispatch = useDispatch();
    const myCreationsDetailList = useSelector(state => state.community.myCreationsDetailList);
    const myCreationsDetailInfo = useSelector(state => state.community.myCreationsDetailInfo);
    const myCreationsDetailPageInfo = useSelector(state => state.community.myCreationsDetailPageInfo);
    useLocalStore();
    useEffect(() => {
        dispatch(FJActionCommunity.initMyCreationsListAction());
    }, [dispatch]);

    const gotoBack = useCallback(() => {
        dispatch(setSliceMyCreationsPageScene(FJConstant.DEFAULT));
    }, [dispatch]);
    const getMoreMyCreationsDetailData = useCallback(() => {
        dispatch(FJActionCommunity.getMoreMyCreationsDetailListAction());
    }, [dispatch]);

    return (
        <FJMyCreationsDetail
            active={active}
            myCreationsDetailInfo={myCreationsDetailInfo}
            gotoBack={gotoBack}
            myCreationsDetailList={myCreationsDetailList}
            getMoreData={getMoreMyCreationsDetailData}
            myCreationsDetailPageInfo={myCreationsDetailPageInfo}
        />
    );
};

FJMyCreationsDetailContainer.propTypes = {
    active: PropTypes.bool.isRequired,
};

export default FJMyCreationsDetailContainer;
